import { NgModule } from '@angular/core';
import { AmdInputDirective } from './input.directive';
export class AmdInputModule {
}
AmdInputModule.decorators = [
    { type: NgModule, args: [{
                declarations: [AmdInputDirective],
                exports: [AmdInputDirective]
            },] },
];
/**
 * @nocollapse
 */
AmdInputModule.ctorParameters = () => [];
function AmdInputModule_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdInputModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdInputModule.ctorParameters;
}
//# sourceMappingURL=input.module.js.map
//# sourceMappingURL=input.module.js.map
